// Last updated: 2026-05-14T04:21:00

export const works = [
  {
    id: 1,
    index: '/ 01',
    title: 'Empório do Café',
    tags: 'Web Design, E-commerce, UX/UI',
    image: '/emporio-cafe/ezgif-frame-001.jpg',
    video: '/emporio-cafe/animation.mp4',
  },
  {
    id: 2,
    index: '/ 02',
    title: 'Dhal',
    tags: 'Identidade Visual, Branding, Design',
    image: '/projeto-dhal.avif',
  },
  {
    id: 3,
    index: '/ 03',
    title: 'Zenorix',
    tags: 'Identidade Visual, Branding, UI Design',
    image: '/projeto-zenorix-v3.avif',
  },
  {
    id: 4,
    index: '/ 04',
    title: 'Açaí Delivery',
    tags: 'App Design, Delivery, UX/UI',
    image: '/acai-delivery/ezgif-frame-001.jpg',
    video: '/acai-delivery/animation.mp4',
  },
  {
    id: 5,
    index: '/ 05',
    title: 'Agro Estratégico',
    tags: 'Design Gráfico, Agro, Branding',
    image: '/projeto-agro.avif',
  },
  {
    id: 6,
    index: '/ 06',
    title: 'Inglês Corporativo',
    tags: 'Marketing Digital, Educação, Social Media',
    image: '/projeto-ingles.avif',
  },
  {
    id: 7,
    index: '/ 07',
    title: 'Jardinagem Premium',
    tags: 'Identidade Visual, Jardinagem, Design',
    image: '/projeto-jardinagem.avif',
  },
  {
    id: 8,
    index: '/ 08',
    title: 'Timelapse Construtora',
    tags: 'Vídeo, Timelapse, Construção Civil',
    image: '/timelapse-construtora/ezgif-frame-001.jpg',
    video: '/timelapse-construtora/animation.mp4',
  },
];

export const solutions = [
  {
    num: '01',
    title: 'Estratégia',
    image: 'https://framerusercontent.com/images/lb2WKt5eZBOPXSLBj2omGqrLCs.jpeg?scale-down-to=1024',
    items: ['Pesquisa e Imersão', 'Definição de Objetivos', 'Planejamento de Estrutura', 'Produção/Prototipação'],
  },
  {
    num: '02',
    title: 'Design',
    image: 'https://framerusercontent.com/images/aDc7XBdQgT4kJ7X1FwiGyvMU1Z8.jpeg?width=904&height=1200',
    items: ['Identidade visual', 'Peças digitais e analógicas', 'Ilustrações', 'UI/UX'],
  },
  {
    num: '03',
    title: 'DEV/WEB',
    image: 'https://framerusercontent.com/images/VSzFPsKLujYPKKGCxmRrBSnJw.jpeg?width=904&height=1200',
    items: ['Full Stack', 'Web app', 'Android/Ios', 'Testes', 'Deploy'],
  },
  {
    num: '04',
    title: 'ANIMAÇÃO',
    image: 'https://framerusercontent.com/images/tAKLygF5hl62MPVXKMMlrJKSkk.jpeg?width=904&height=1200',
    items: ['Motion Design', 'UI Motion', 'Logo Animation', 'Cinematic AI Animation', 'Animação Social Media'],
  },
];

export const process = [
  {
    num: '/ 01',
    title: 'Descobrir',
    desc: 'Todo projeto começa com a compreensão dos seus objetivos. Dedico tempo para aprender sobre sua marca, público-alvo e requisitos específicos.',
    highlight: true,
  },
  {
    num: '/ 02',
    title: 'Design',
    desc: 'Assim que a direção está clara, crio designs limpos, modernos e centrados no usuário, focando tanto na estética quanto na usabilidade.',
    highlight: false,
  },
  {
    num: '/ 03',
    title: 'Desenvolver',
    desc: 'Sites cinematográficos a aplicações web, Android e Ios totalmente dinâmicas, construo sites escaláveis e de fácil manutenção que funcionam perfeitamente em todos os dispositivos.',
    highlight: false,
  },
  {
    num: '/ 04',
    title: 'Entregar',
    desc: 'Garanto que o produto final seja testado e otimizado antes do lançamento. Após a entrega, ofereço suporte contínuo conforme necessário.',
    highlight: false,
  },
];

export const testimonials = [
  {
    quote:
      'Trabalhar com Maycon foi uma mudança absoluta para nossa marca. Ele pegou nossa visão e a elevou com um design web elegante, branding atencioso e uma experiência de e-commerce perfeita. Nossas conversões aumentaram 40% após o lançamento!',
    name: 'Sarah Mitchell',
    role: 'Fundadora, Lumiere Skincare',
    avatar: 'https://framerusercontent.com/images/OvEV8wbEcyZinA3tXgvBORGOnc.jpeg?width=904&height=1200',
  },
  {
    quote:
      'Precisávamos de modelagem 3D de alta qualidade para nossas apresentações e o Maycon entregou além das expectativas. Sua atenção aos detalhes e habilidades técnicas deram vida às nossas ideias. Recomendo muito!',
    name: 'Daniel Kim',
    role: 'Diretor Criativo, Nova',
    avatar: 'https://framerusercontent.com/images/OAptuWFNfA2ykYxM7NRYIeUI3Xc.png?width=1024&height=1024',
  },
  {
    quote:
      'Maycon redesenhou nosso site e deu à nossa marca a renovação necessária. O processo foi tranquilo, criativo e incrivelmente colaborativo. Ele realmente entende tanto de design quanto de objetivos de negócio.',
    name: 'Maria Lopez',
    role: 'Gerente de Marketing, GreenVibe',
    avatar: 'https://framerusercontent.com/images/twX7Aze7rBnuv17EgJDs5qO4nE.jpeg?width=904&height=1200',
  },
  {
    quote:
      'Do design UI/UX ao desenvolvimento full-stack, Maycon lidou com nosso dashboard SaaS como um profissional. Sua expertise é incomparável. A performance e o design falam por si.',
    name: 'Jason Reed',
    role: 'CEO, TechForge Solutions',
    avatar: 'https://framerusercontent.com/images/XHiEbNhKoPu6JHM6kyXSHoqg.jpeg?width=904&height=1200',
  },
];

export const awards = [
  {
    title: 'Grupo Grão de Ouro',
    date: 'JUL 2024 - OUT 2025',
    role: 'Designer Gráfico',
    desc: 'Comunicação digital e impressa, identidade visual, materiais promocionais e desenvolvimento de embalagens (Nutrimax e Nutrividas).',
  },
  {
    title: "Cafeteria Don'ana",
    date: 'MAR 2021 - OUT 2023',
    role: 'Analista de Marketing',
    desc: 'Aumento de alcance e engajamento, conteúdo para mídias sociais e alinhamento de estratégias com vendas.',
  },

  {
    title: 'Agência Taruga',
    date: 'DEZ 2018 - MAR 2021',
    role: 'Designer Gráfico',
    desc: 'Publicidade inteligente e atraente para gerar negócios para grandes e pequenas empresas.',
  },

  {
    title: 'Unifenas',
    date: 'ABR 2014 - OUT 2018',
    role: 'Designer Gráfico',
    desc: 'Campanhas publicitárias e inovações na área de comunicação da universidade.',
  },

];


export const HERO_IMAGE = '/hero_bg_new.avif';
export const BG_GLOW = 'https://framerusercontent.com/images/vAhqnzkThVFz1iiu5pCyQFokec.png?width=1920&height=5594';
export const AI_BG = '/Maycon Robert-ciborg.avif';
export const PROFESSIONAL_IMAGE = '/Maycon-profissional2.avif';
